import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper-login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminInput = _resolveComponent("AdminInput")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: "assets/administrator/LogoYellowAv.svg",
        alt: "logo-av",
        class: "logo"
      }, null, -1)),
      _createVNode(_component_AdminInput, {
        text: _ctx.email.val,
        "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email.val) = $event)),
        value: _ctx.email.val,
        label: 'Usuario',
        "has-error": _ctx.email.enabled,
        error: _ctx.email.errors.length === 0 ? '' : _ctx.email.errors[0]
      }, null, 8, ["text", "value", "has-error", "error"]),
      _createVNode(_component_AdminInput, {
        "is-password": true,
        text: _ctx.password.val,
        "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.val) = $event)),
        value: _ctx.password.val,
        label: 'Contraseña',
        "has-error": _ctx.password.enabled,
        error: _ctx.password.errors.length === 0 ? '' : _ctx.password.errors[0]
      }, null, 8, ["text", "value", "has-error", "error"]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Ingresar',
        "is-disabled": _ctx.successForm
      }, null, 8, ["is-disabled"])
    ])
  ]))
}